<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Attendance
    </div>
    <div class="card-body" style="overflow: auto; height: 450px;">
        <div class="row">
            <div class="col-md mx-1 px-1 bghighlight">
                <label class="text-label">Employee</label><br />
                <label class="Label1">
                    <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
                        <div class="col-2">
                            <img *ngIf="InputData.Photo != null && InputData.Photo != ''" mat-card-image
                                class="userImage" [src]="common.PhotoLink(InputData.Photo)" />
                            <div *ngIf="InputData.Photo == null || InputData.Photo == ''" class="initial-image">
                                <div class="image">
                                    {{common.getInitial(InputData.EmpName)}}
                                </div>
                            </div>
                        </div>
                        <div class="col-9 userdetail">
                            <span class="text-label">{{InputData.EmpName}}</span><br />
                            <span class="text-label-light">#{{InputData.EmpCode}}</span><br />
                            <span class="text-label-light">{{InputData.DesignationName}}</span>
                        </div>
                    </div>
                </label>
            </div>
        </div>
        <div class="row" *ngIf="InputData.IsDate">
            <div class="col-md-3">
                <label class="text-label">Month and Year</label>
                <ngb-datepicker #dp [(ngModel)]="selectedMonth" class="month-year" name="dateselect"
                    (navigate)="selectedMonth= $event.next;onNavigate()" (ngModelChange)="onchange()"
                    [minDate]="minDate" [maxDate]="maxDate" style="width: 100%;" aria-hidden="true"></ngb-datepicker>
            </div>
            <div class="col-md-3"><br>
                <button type="button" name="Search" class="btn btn-sm btn-primary" [disabled]="isDisabled"
                    (click)="getData()">
                    <i class="bi bi-search" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Search':'Loading...'}}
                </button>
            </div>
        </div>
        <div class="card border-radius-0 mt-1 p-0">
            <div class="card-header">
                Details of {{ InputData.IsDate ? selectedMonthFormatted: InputData.MonthYear}}
            </div>
            <div class="card-body p-1" style="overflow: auto;">
                <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                    class="customeDatatable table table-bordered">
                    <thead class="table-light">
                        <tr>
                            <th scope="col" style="display: none;">Emp Name</th>
                            <th scope="col">AttendanceDate</th>
                            <th scope="col">In Time</th>
                            <th scope="col">Out Time</th>
                            <th scope="col">Attendance Remark</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let site of AttendanceSummary; let i = index">
                            <td style="display: none;">{{ site['EmpName'] }}</td>
                            <td>{{ site['AttendanceDate'] }}</td>
                            <td>{{ site['InTime'] }}</td>
                            <td>{{ site['OutTime'] }}</td>
                            <td>{{ site['AttendanceRemark'] }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled" (click)="Cancel()"
                    autofocus="true" #cancelButton id="cancelButton">
                    <i class="bi bi-x-lg" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>